// extracted by mini-css-extract-plugin
export default {"carousel":"carousel_carousel__npA93","left":"carousel_left__CxJQf","right":"carousel_right__+Q+jo","fullscreen":"carousel_fullscreen__FmcN1","index":"carousel_index__-L1r7"};